import { findOneById }             from '../../../utilities/idResolution.js';


export const extractDataObject = (orderedSelectedIds, barIndex, cos_txns) => {
    /*
        a. get the company id we need the data from, via the orderedSelectedIds based on the corresponding index that bar we are hovering over is at
        b. extract that company's data object based on its id from the companies array of objects
    */
    console.log("[SUCCESS - ENTERTING NEP TECHNIQUE STEP 1 FOR TOOLTIP COMPANION]: Normalization / Parsing / Extraction")
    const id = orderedSelectedIds[barIndex]
    const result = findOneById(cos_txns, id)
    console.log("[RESULT] Extracted CO_TXN Running Tooltip Companion Assembler Against: ", result)
    return result
}